module.exports = __webpack_public_path__ + "static/media/map.d482ec08.png";